package com.kaihuoy.components.common

import com.kaihuoy.shared.data.*


fun getGreeting(name: String?): String {
    val hour = kotlin.js.Date().getHours()
    val baseGreeting = when (hour) {
        in 5..10 -> "Hyvää huomenta"
        in 11..17 -> "Hyvää päivää"
        in 18..22 -> "Hyvää iltaa"
        else -> "Hyvää yötä"
    }
    return if (!name.isNullOrBlank()) "$baseGreeting, $name" else "$baseGreeting"
}